import { useMemo } from 'react';
import {
  KovCollapsed,
  KovTitle,
  KovParagraph,
  KovImage,
  KovImageGroup,
  KovAttachments,
  KovBlockQuote,
  KovLegal,
  KovReferenceGroup,
  KovSummary,
  KovVideo,
  KovExample,
} from '../components/contentBlock';

const useCustomContentBlockComponents = (customComponents = {}) => {
  const components = useMemo(
    () => ({
      Title: customComponents.title ?? KovTitle,
      Collapsed: customComponents.collapsed ?? KovCollapsed,
      Paragraph: customComponents.paragraph ?? KovParagraph,
      Image: customComponents.image ?? KovImage,
      ImageGroup: customComponents.imageGroup ?? KovImageGroup,
      Summary: customComponents.summary ?? KovSummary,
      Legal: customComponents.legal ?? KovLegal,
      Quote: customComponents.quote ?? KovBlockQuote,
      Video: customComponents.video ?? KovVideo,
      ReferenceGroup: customComponents.referenceGroup ?? KovReferenceGroup,
      Attachments: customComponents.attachments ?? KovAttachments,
      Example: customComponents.example ?? KovExample,
    }),
    [customComponents]
  );

  return components;
};

export default useCustomContentBlockComponents;
